export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6b-8572dc412372202036dab0e8baca7105.webp";